module.exports = __webpack_public_path__ + "img/ps-51.bd51f941.jpg";